import colors from "../../base/colors";

const { transparent, primary } = colors;

export default {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      borderColor: primary.main,
      "&.textFieldBright": {
        color: "#ffffff",
      },
    },
  },
};
